export const LEGAL_CONTENT = {
    KVKK: {
        title: "6698 SAYILI KVKK KAPSAMINDA AYDINLATMA METNİ",
        content: `
1. Veri Sorumlusu
Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, SNAPP Yazılım ve Spor Teknolojileri (“SNAPP” veya “Şirket”) tarafından kullanıcılarımıza ait kişisel verilerin işlenmesine ilişkin usul ve esasları belirlemek amacıyla hazırlanmıştır.

2. İşlenen Kişisel Verileriniz
SNAPP platformunu kullanımınız kapsamında aşağıdaki verileriniz işlenmektedir:
- Kimlik Bilgileri: Ad, soyad, doğum tarihi.
- İletişim Bilgileri: E-posta adresi, telefon numarası.
- İşlem Güvenliği Bilgileri: IP adresi, log kayıtları, cihaz bilgileri, çerez verileri.
- Sporcu/Performans Verileri: Takım üyeliği, pozisyon, fiziksel ölçümler, oyun istatistikleri, video analiz içerikleri.

3. Kişisel Verilerin İşlenme Amaçları
Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
- Platform üyeliğinin tesisi, doğrulanması ve yönetilmesi.
- Video analiz, klip oluşturma ve performans takip hizmetlerinin sunulması.
- Takım içi hiyerarşi ve yetkilendirme süreçlerinin (antrenör-oyuncu) yönetilmesi.
- Teknik sorunların giderilmesi ve sistem güvenliğinin optimize edilmesi.
- Yasal mevzuat kapsamındaki bildirim yükümlülüklerinin yerine getirilmesi.

4. Kişisel Verilerin Aktarılması
Verileriniz, yalnızca hizmetin sunulabilmesi için gerekli olan teknik altyapı sağlayıcıları (bulut sunucu hizmetleri vb.) ve hukuki bir zorunluluk olması halinde yetkili kamu kurum ve kuruluşları ile paylaşılmaktadır. SNAPP, takımlar arasındaki veri izolasyonunu garanti eder; bir takıma ait veriler kesinlikle başka bir takım veya üçüncü tarafla paylaşılmaz.

5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi
Verileriniz, platforma kayıt olmanız, video yüklemeniz ve etkileşimleriniz aracılığıyla elektronik ortamda toplanmaktadır. İşleme faaliyeti; “bir sözleşmenin kurulması veya ifası”, “veri sorumlusunun hukuki yükümlülüğü” ve “ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla meşru menfaat” hukuki sebeplerine dayanmaktadır.

6. İlgili Kişinin Hakları (KVKK md. 11)
Kanun uyarınca; verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, silinmesini veya düzeltilmesini isteme ve otomatik sistemlerle analiz edilmesine itiraz etme haklarına sahipsiniz. Haklarınızı kullanmak için destek@snapp.com adresine başvurabilirsiniz.`
    },
    PRIVACY: {
        title: "GİZLİLİK POLİTİKASI",
        content: `
GÜNCELLEME TARİHİ: 27.01.2026

SNAPP olarak, kullanıcılarımızın gizliliğini en üst düzeyde korumayı taahhüt ediyoruz. Bu politika, platformumuzda toplanan verilerin nasıl korunduğunu açıklar.

1. Veri İzolasyonu ve Güvenliği
SNAPP, "Takım İzolasyonu" mimarisiyle çalışır. Her takımın yüklediği video, not ve istatistik verileri şifrelenmiş veri tabanlarında saklanır. Antrenörler tarafından yetkilendirilmemiş hiç kimse (diğer takımlar dahil) bu verilere erişemez.

2. Video İçerikleri
Yüklenen maç ve antrenman görüntüleri yalnızca analiz amaçlı kullanılır. SNAPP, bu videolar üzerinden reklam profillemesi yapmaz veya içerikleri üçüncü taraf pazarlama şirketlerine satmaz.

3. Çerezler (Cookies)
Platformun işlevselliğini sağlamak (oturum yönetimi, dil tercihi) amacıyla zorunlu çerezler kullanılmaktadır. Analitik çerezler ise kullanıcı deneyimini iyileştirmek için anonimleştirilmiş veriler toplar.

4. Veri Saklama ve İmha
Hesabınızı sildiğinizde, yasal olarak saklanması zorunlu olan veriler dışındaki tüm kişisel verileriniz ve yüklediğiniz içerikler sistemimizden kalıcı olarak temizlenir.

5. Çocukların Gizliliği
Platformumuz reşit olmayan sporcular tarafından kullanılıyorsa, kayıt işlemi ilgili spor kulübü veya veli gözetiminde/izniyle gerçekleştirilmelidir.`
    },
    TERMS: {
        title: "KULLANIM ŞARTLARI VE ÜYELİK SÖZLEŞMESİ",
        content: `
1. Taraflar
İşbu sözleşme, SNAPP platformu ile platforma üye olan kullanıcı ("Kullanıcı") arasında akdedilmiştir.

2. Hizmetin Kullanımı
SNAPP, spor analiz ve yönetim araçları sunan bir yazılım çözümüdür. Kullanıcı, platformu yalnızca spor analiz amaçlı, etik kurallar ve yasalar çerçevesinde kullanacağını taahhüt eder.

3. Fikri Mülkiyet
Platformun yazılımı, tasarımı ve markası SNAPP'e aittir. Kullanıcıların yüklediği videoların mülkiyeti ilgili kullanıcıya/takıma aittir; ancak kullanıcı, platformun işlevlerini yerine getirebilmesi için bu içerikleri işleme hakkını SNAPP'e tanır.

4. Kullanım Kısıtlamaları ve İhlaller
Aşağıdaki eylemler kesinlikle yasaktır:
- Diğer takımların verilerine yetkisiz erişim teşebbüsü.
- Platforma telif hakkı ihlali içeren veya hukuka aykırı videolar yüklemek.
- Yazılımın tersine mühendislik yoluyla kopyalanması veya kaynak koduna erişim çabası.
İhlal durumunda SNAPP, hesabı önceden bildirim yapmaksızın askıya alma veya iptal etme hakkını saklı tutar.

5. Sorumluluk Reddi
SNAPP, platformun kesintisiz çalışması için azami çabayı gösterir ancak teknik aksaklıklardan kaynaklı veri kayıplarından sorumlu tutulamaz. Kullanıcı, önemli verilerinin yedeklerini almakla yükümlüdür.

6. Değişiklikler
SNAPP, hizmet şartlarını güncelleme hakkını saklı tutar. Önemli değişiklikler kullanıcılara platform içi bildirimlerle duyurulur.`
    }
};
